function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMailRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.586 7l-8.88 8.879a1 1 0 01-1.413 0L6.413 7h19.173zM13.879 17.293a2.99 2.99 0 002.12.877 2.99 2.99 0 002.122-.877L28.707 6.707l.219-.219A1.995 1.995 0 0027 5H5c-.927 0-1.698.633-1.926 1.488l.219.219 10.586 10.586z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 11.242V25H5V11.242l-2-2V25a2 2 0 002 2h22a2 2 0 002-2V9.242l-2 2z",
    fill: props.color
  }));
}

export default SvgIconMailRexOutline;